import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--pl-icon-system-error-weak)",
      d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--pl-icon-system-error)",
      d: "M9.71 8.293a1 1 0 0 0-1.415 1.414L10.587 12l-2.292 2.292a1 1 0 0 0 1.415 1.414L12 13.413l2.292 2.292a1 1 0 0 0 1.414-1.415L13.416 12l2.291-2.291a1 1 0 0 0-1.414-1.415l-2.291 2.292z"
    }, null, -1)
  ])))
}
export default { render: render }